// dispatch(fetchDocuments("client-ready"));
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { closeViewDocument, fetchDocuments, openViewDocument, resetTabState, setSelectedDocumentIds, updateRequestBody } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import TableComponent from "../../TableComponent/TableComponent";
import ViewDocumentModal from "../Modal/ViewDocumentModal";
import EngageTranslationClientReadyTableColumns from "../TableComponent/EngageTranslationClientReadyTableColumns";
import { TableRowSelection } from "antd/es/table/interface";
import { Table } from "antd";

function ClientReadyContent(props: any) {
  const dispatch = useAppDispatch();
  const clientReadyTabState = useSelector((state: RootState) => state.engageTranslationState.clientReadyState);
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = {
      ...clientReadyTabState.currentRequestBody,
      sortColumn: sorter.field,
      isAsc: isAscend(sorter.order),
    };
    // dispatch(resetTabState("client-ready"));
    dispatch(resetTabState("client-ready"));

    dispatch(updateRequestBody({ requestBody: newSortingRequestBody, view: "client-ready" }));
    dispatch(fetchDocuments({ view: "client-ready" }));
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    dispatch(setSelectedDocumentIds({ selectedDocumentIds: newSelectedRowKeys }));
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys: clientReadyTabState.selectedDocumentIds,
    onChange: onSelectChange,
  };

  return (
    <div className="d-flex flex-column full-flex h-100 mt-2 px-2">
      <ViewDocumentModal
        open={() => dispatch(openViewDocument())}
        close={() => dispatch(closeViewDocument())}
        openState={clientReadyTabState.viewDocumentOpenState}
        // record={record}
      />

      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={clientReadyTabState.data}
          tableKey={"client-ready"}
          columns={EngageTranslationClientReadyTableColumns}
          loading={clientReadyTabState.loading}
          {...(clientReadyTabState.data.length > 0 ? { rowSelection } : {})}
          pagination={clientReadyTabState.pagination}
          handleTableSorting={handleTableSorting}
        />
      </div>
    </div>
  );
}

export default memo(ClientReadyContent);
